<template>
    <td :colKey="colKey" :class="[classes]">
        <div class="d-flex justify-content-center">
            <div class="custom-control custom-switch pl-5">
                <input type="checkbox" class="custom-control-input table_selector_input" :value="elementId" :id="`${tableId}_${elementId}_selector_input`">
                <label class="custom-control-label" :for="`${tableId}_${elementId}_selector_input`"></label>
            </div>
        </div>
    </td>
</template>

<script>
export default {
    props: {
        colKey: {
            type: String,
            required: true,
        },
        classes: {
            type: Array,
            required: false,
            default: function(){
                return [];
            },
        },
        elementId: {
            type: Number,
            required: true,
        },
        tableId: {
            type: String,
            required: true,
        }
    },
}
</script>
